import {Well, WellEntity} from "../../../model/well";
import {contains} from "../../../util/util";
import {createParamSelector, getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";

export type WellSelectorProps = {
  regionId?: string;
  siteId?: string;
  showDoNotUse?: boolean;
};

const getRegionIdParam = createParamSelector<WellSelectorProps | undefined, string | undefined>(params => params?.regionId);
const getSiteIdParam = createParamSelector<WellSelectorProps | undefined, string | undefined>(params => params?.siteId);
const getShowDoNotUseParam = createParamSelector<WellSelectorProps | undefined, boolean | undefined>(params => params?.showDoNotUse);

export const wellsSelector = () => createSelector(
  [getUseQueryResultData<Well[]>, getRegionIdParam, getSiteIdParam, getShowDoNotUseParam],
  (data, regionId, siteId, showDoNotUse) => {
    return selectWellsAndTransform(
      data ?? [], {
        regionId: regionId,
        siteId: siteId,
        showDoNotUse: showDoNotUse
      }
    );
  }
);

export const wellSelector = () => createSelector(
  [getUseQueryResultData<Well>],
  (data) => {
    return data ? transformWell(data) : undefined;
  }
);

export const selectWells = (values?: Well[], selector?: WellSelectorProps): Well[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;

    if (selector?.regionId) {
      if (!contains(v.regionList, id => id === selector.regionId)) {
        filterIn = false;
      }
    }

    if (selector?.siteId) {
      if (selector.siteId !== v.siteId) {
        filterIn = false;
      }
    }

    const showDoNotUse = selector?.showDoNotUse ?? false;
    if (filterIn && !showDoNotUse && v.doNotUse) {
      filterIn = false;
    }

    return filterIn;
  });
};

export const transformWell = (value: Well): WellEntity => {
  return WellEntity.from(value)
}

export const selectWellsAndTransform = (values?: Well[], selector?: WellSelectorProps): WellEntity[] => {
  const selected = selectWells(values, selector);
  return selected.map(transformWell);
};
